import React from "react";
import ReactTooltip from 'react-tooltip';
import Dropzone from "react-dropzone";
import { Row, Col, Spinner, Button, Image, Modal, Alert, Form, InputGroup, Card, Placeholder } from "react-bootstrap";
import { FaUpload, FaHdd, FaRegCheckCircle, FaExternalLinkAlt, FaSearch } from "react-icons/fa";
import { MdOutlinePageview } from "react-icons/md";
import { IoCloseOutline } from "react-icons/io5";
import { AiOutlineCloseCircle, AiOutlineUpload } from "react-icons/ai";
import { GoLinkExternal } from "react-icons/go";

class _dropzone extends React.Component {

    state = {
        preview: {
            show: false,
            src: ""
        },
        heg: false,
        heg_search: "",
        heg_files: [],
        heg_loading: false,
        link: false
    }

    edmGetFile = async () => {
        this.setState({ heg_loading: true });
        const _res = await this.props.api(
            {
                data: {
                    name: "user_files",
                    value: this.props.user.UserHeliosId,
                    identifikator: this.state.heg_search
                },
                method: "post",
                type: "procedure",
                param: "api_direct_hellapp_common",
                user: this.props.user
            }
        )

        this.setState({ heg_loading: false });
        if (_res.status == 200) {
            this.setState({ heg_files: _res.data });
        }
    }

    saveEDM = async (idx, name, size, content) => {
        const _res = await this.props.api(
            {
                data: {
                    id: 1,
                    fileName: name,
                    fileContent: content,
                    fileSize: size,
                    userid: this.props.user.UserHeliosId
                },
                type: "function",
                param: "4000542",
                method: "post",
                user: this.props.user
            }
        )
        if (_res) return _res;

        return null;
    }

    uploadFile = (f, idx) => {
        let files = this.props.files;
        let reader = new FileReader();
        reader.readAsDataURL(f);
        reader.onload = () => {
            let res = null
            files[idx] = {
                ...files[idx],
                content: reader.result,
                upload: res.status == 200 ? true : false,
                uploadStatus: res.data,
                id: res.status == 200 ? res.data : -1,
                folder: res.status == 200 ? 4000232 : -1
            }
            this.setState({ files: files });
            this.props.setfiles(files)
            //this.saveEDM(idx, files[idx].name, files[idx].size, reader.result.split(",")[1]).then(res => {


            //});
        };
        reader.onerror = function (error) {
        };
    }

    checkHegFile = (e, idx) => {
        let heg = this.state.heg_files;
        heg[idx] = { ...heg[idx], select: e.target.checked };
        this.setState({ heg_files: heg });
    }

    addSelectedHegFile = () => {
        let files = this.props.files;
        let heg = this.state.heg_files;
        heg.filter(f => f.select).map(f => {
            const nFile = {
                id: f.cislo_subjektu,
                folder: f.cislo_poradace,
                path: f.physical_name,
                name: f.physical_name,
                type: "file.type",
                size: f.data_size,
                content: "",
                upload: true,
                deletable: true
            };
            files.push(nFile);
            this.props.setfiles(files)
        })
        this.setState({ heg: false })
    }

    removeEntries = (f) => {
        let files = this.props.files;
        files.splice(f, 1);
        this.props.setfiles(files)
    }

    pushFile = (f) => {
        let files = this.props.files;
        f.forEach(file => {
            const idx = files.length;
            const nFile = {
                id: -1,
                folder: -1,
                path: file.path,
                name: file.name,
                type: file.type,
                size: file.size,
                content: "",
                upload: true,
                deletable: true
            };
            files.push(nFile);

            this.props.setfiles(files)
            //this.uploadFile(file, idx);
        });
    }

    componentDidUpdate() {

        ReactTooltip.rebuild();
    }

    render() {
        return (
            <>
                <Modal
                    show={this.state.heg}
                    onHide={() => this.setState({ heg: false })}
                    centered
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    backdrop="static"
                    keyboard={false}

                >
                    <Modal.Header closeButton>
                    </Modal.Header>
                    {this.state.heg_files.length == 0 && (
                        <Alert variant="info">Zační tím, že zadáš <strong>název souboru</strong>, který chceš vyhledat</Alert>
                    )}
                    {this.state.heg_files.length != 0 && (
                        <Alert variant="warning">Počet nalezených souborů <strong>{this.state.heg_files.length}</strong></Alert>
                    )}
                    <Modal.Body>
                        <InputGroup>
                            <Form.Control autoFocus value={this.state.heg_search} onKeyDown={(e) => {
                                if (e.key == "Enter") this.edmGetFile();
                            }} onChange={(e) => this.setState({ heg_search: e.target.value })} />
                            <Button disabled={this.state.heg_loading} variant="danger" onClick={this.edmGetFile}>{this.state.heg_loading ? <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            /> : <FaSearch />}</Button>
                        </InputGroup>
                        <Form.Text>Název souboru</Form.Text>
                        <Row className="mt-4">
                            <Col>
                                {this.state.heg_loading && (
                                    <Card bg="uni" className="mb-2">
                                        <Card.Body>
                                            <Row>
                                                <Col xs={8}>
                                                    <Placeholder animation="glow">
                                                        <Placeholder xs={6} />
                                                    </Placeholder>
                                                </Col>
                                                <Col xs={4}>
                                                    <Placeholder animation="glow">
                                                        <Placeholder xs={6} />
                                                    </Placeholder>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xs={8}>
                                                    <Placeholder animation="glow">
                                                        <Placeholder xs={6} />
                                                    </Placeholder>
                                                </Col>
                                                <Col xs={4}>
                                                    <Placeholder animation="glow">
                                                        <Placeholder xs={6} />
                                                    </Placeholder>
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                )}
                                {this.state.heg_files.map((file, idx) => {
                                    return (
                                        <Card bg="uni" className="mb-2">
                                            <Card.Body>
                                                <Row>
                                                    <Col xs={10}>
                                                        <Row>
                                                            <Col xs={8}>
                                                                <strong>{file.nazev_subjektu}</strong>
                                                            </Col>
                                                            <Col xs={4}>
                                                                <small className="text-muted">{new Date(file.created).toLocaleDateString()} </small>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col xs={8}>
                                                                <span>{file.physical_name}</span>
                                                            </Col>
                                                            <Col xs={4}>
                                                                <small className="text-muted">{file.data_size > 1024000 ? Math.round(file.data_size / 1000000) + " MB" : Math.round(file.data_size / 1000) + " KB"} </small>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                    <Col xs={2} className="d-flex justify-content-end align-items-center">

                                                        <Button variant="light" data-tip="Náhled" onClick={() => this.setState({ preview: { show: true, src: "" } })}>
                                                            <MdOutlinePageview className="fs-20 c-secondary" />
                                                        </Button>
                                                        <Form.Check className="ms-2" checked={file.select} onChange={(e) => this.checkHegFile(e, idx)} />
                                                    </Col>
                                                </Row>
                                            </Card.Body>
                                        </Card>)
                                })}
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Row className="mb-2 me-1">
                        <Col className="d-flex justify-content-end">
                            <Button variant="success" disabled={this.state.heg_files.filter(f => f.select).length == 0} onClick={this.addSelectedHegFile}>
                                Přidat vybrané ({this.state.heg_files.filter(f => f.select).length})
                            </Button>
                        </Col>
                    </Row>

                </Modal>

                <Modal
                    show={this.state.preview.show}
                    onHide={() => this.setState({ preview: { show: false } })}
                    centered
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    backdrop="static"
                    keyboard={false}

                >
                    <Modal.Header closeButton>
                        Náhled
                    </Modal.Header>
                    <Modal.Body>
                        <div className="iframe-wrap">
                            <iframe className="iframe" src={this.state.preview.src} />
                        </div>
                    </Modal.Body>
                </Modal>
                <Dropzone className={this.props.className} onDrop={acceptedFiles => { this.pushFile(acceptedFiles) }}>
                    {({ getRootProps, getInputProps }) => (
                        <div className="c-dropzone">
                            <Row className="mb-2">
                                <Col xs={3} {...getRootProps()}>
                                    <input {...getInputProps()} />
                                    <Row>
                                        <Col>
                                            <span className="h5">
                                                Vyber dokument(y)
                                            </span>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className="d-flex align-items-center">
                                            <span>Můžeš je sem přetáhnout</span>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={9} data-tip="Vybrat soubory z úložiště zařízení" {...getRootProps()} className="d-flex justify-content-end align-items-center cursor-pointer">
                                    <input {...getInputProps()} />
                                    <Row>
                                        <Col>
                                            <FaHdd className="fs-20 me-2" />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <span>Zařízení</span>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            {this.props.files?.map((f, idx) => (
                                <Row className="mb-2 c-dropzone-file">
                                    <Col xs={12} className="d-flex justify-content-between align-items-center">
                                        {f.upload == null && (
                                            <>
                                                <Spinner
                                                    className="c-dropzone-spinner"
                                                    variant="danger"
                                                    as="span"
                                                    animation="border"
                                                    size="sm"
                                                    role="status"
                                                    aria-hidden="true"
                                                />
                                                <AiOutlineUpload className="c-dropzone-spinner-img" />
                                            </>
                                        )}
                                        {f.upload == true && (
                                            <>
                                                <FaRegCheckCircle data-tip={f.id} className="c-dropzone-spinner-img fs-25 c-success me-4" />
                                            </>
                                        )}
                                        {f.upload == false && (
                                            <>
                                                <AiOutlineCloseCircle data-tip={f.uploadStatus} className="c-dropzone-spinner-img fs-25 c-danger me-4" />
                                            </>
                                        )}

                                        <span className="c-dropzone-file-name me-4" data-tip={f.name}>{f.name}</span>
                                        <span className="me-4">{f.size > 1024000 ? Math.round(f.size / 1000000) + " MB" : Math.round(f.size / 1000) + " KB"} </span>
                                        {f.upload && (
                                            <>
                                                {f.deletable && (
                                                    <Col className="d-flex justify-content-end">
                                                        <Button variant="light" className='' data-tip="Smazat" onClick={() => this.removeEntries(idx)}>
                                                            <IoCloseOutline className='c-danger fs-20' />
                                                        </Button>
                                                    </Col>
                                                )}
                                            </>
                                        )}
                                    </Col>

                                </Row>
                            ))}
                        </div>
                    )}
                </Dropzone>
            </>
        )
    }
}

export default _dropzone;